/* eslint-disable no-case-declarations */
/* eslint-disable react/jsx-no-constructed-context-values */
/*
 * Author M. Atoar Rahman
 * Title: Center Stock Loss
 * Description: Center Stock Loss
 * Date: 16/06/2022
 */

import { createContext, useContext, useReducer, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import ToastifyService from '../../../services/ToastifyService';
import UrlService from '../../../services/UrlService';
import { reload } from '../../../Utils';

// Initial State
const initialState = {
    stockLoss: [],
};

// Reducer Function
const reducer = (state, action) => {
    switch (action.type) {
        case 'LIST_DATA':
            return {
                ...state,
                stockLoss: action.payload,
            };
        case 'ADD_REQ':
            return {
                ...state,
                stockLoss: [action.payload, ...state.stockLoss],
            };
        case 'EDIT_REQ':
            const actionPayload = action.payload;

            const updateStockLoss = state.stockLoss.map((el) => {
                if (el.id === actionPayload.id) {
                    return actionPayload;
                }
                return el;
            });
            return {
                ...state,
                stockLoss: updateStockLoss,
            };

        default:
            return state;
    }
};

// Create Context
const ContextAPI = createContext(initialState);

export function useStockLoss() {
    return useContext(ContextAPI);
}

// Provider Component
export function CenterStockLossProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [show, setShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [rowData, setRowData] = useState({});

    // Dependency
    const axiosPrivate = useAxiosPrivate();

    // API Function: Fatch All Data
    const getAllData = async () => {
        try {
            const response = await axiosPrivate.get(UrlService.getAllCenterStockLossUrl(), {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            dispatch({
                type: 'LIST_DATA',
                payload: response?.data?.request_info,
            });
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Data Not Found!');
            }
        }
    };

    // API Function: Add/Edit Data
    const addOrUodateData = async (data, id) => {
        try {
            await axiosPrivate.post(
                id ? UrlService.updateCenterStockLossUrl(id) : UrlService.saveCenterStockLossUrl(),
                JSON.stringify(data),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            if (id != null) {
                ToastifyService.updateNotify('Data Update Successfull');
            } else {
                ToastifyService.saveNotify('Data Create Successfull');
                reload();
            }
            await getAllData();
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else if (id) {
                console.log('Data Update Failed!');
            } else {
                console.log('Data Insert Failed!');
            }
        }
    };

    // Add Stock Loss
    const addStockLoss = (data) => {
        addOrUodateData(data);
        dispatch({
            type: 'ADD_REQ',
            payload: data,
        });
    };

    // Edit Stock Loss
    const editStockLoss = (data, id) => {
        addOrUodateData(data, id);
        dispatch({
            type: 'EDIT_REQ',
            payload: data,
        });
    };

    return (
        <ContextAPI.Provider
            value={{
                stockLoss: state.stockLoss,
                getAllData,
                addStockLoss,
                editStockLoss,
                show,
                setShow,
                showModal,
                setShowModal,
                rowData,
                setRowData,
            }}
        >
            {children}
        </ContextAPI.Provider>
    );
}

export default ContextAPI;
